import { render, staticRenderFns } from "./addCCXS.vue?vue&type=template&id=6feca5a4&"
import script from "./addCCXS.vue?vue&type=script&lang=js&"
export * from "./addCCXS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports